import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "code",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "sale_price",
    type: "money",
    sortable: true,
    searchable: true,
  },
  {
    name: "type",
    type: "translate",
    sortable: true,
    searchable: true,
  },
  {
    name: "threshold",
    type: "number",
    sortable: true,
    searchable: true,
  },
  {
    name: "active",
    type: "boolean",
    sortable: true,
    searchable: true,
  },
  {
    name: "category",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "categories.name",
  },
];

export default function List() {
  return (
    <ResourceListPage
      url="products"
      columns={columns}
      title="services"
      baseQuery={{
        type: {
          $in: ["ONCE", "HOURLY", "DAILY", "MONTHLY", "YEARLY"],
        },
      }}
    />
  );
}
